import { render, staticRenderFns } from "./AddFireProtection.vue?vue&type=template&id=98a57388&scoped=true"
import script from "./AddFireProtection.vue?vue&type=script&lang=js"
export * from "./AddFireProtection.vue?vue&type=script&lang=js"
import style0 from "./AddFireProtection.vue?vue&type=style&index=0&id=98a57388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a57388",
  null
  
)

export default component.exports